@if (visible()) {
    <div
        class="sap-search-progress flex flex-col gap-2 p-4 pb-8 rounded"
        [class.border-red-500]="isError()"
        role="status"
        aria-live="polite"
    >
        <div class="text-sm font-medium">
            {{ phaseKey() | translate }}
        </div>

        @if (!isError()) {
            <div
                class="progress-track w-full h-2 bg-gray-200 rounded overflow-hidden"
                role="progressbar"
                [attr.aria-valuemin]="0"
                [attr.aria-valuemax]="100"
                [attr.aria-valuenow]="isDeterminate() ? percentage() : null"
            >
                @if (isDeterminate()) {
                    <div
                        class="progress-fill h-full bg-light-actionColor dark:bg-dark-actionColor"
                        [style.width.%]="percentage()"
                    ></div>
                } @else {
                    <div class="progress-fill-indeterminate h-full bg-siemens-petrol-500"></div>
                }
            </div>

            @if (isDeterminate()) {
                <div class="text-xs text-gray-600">
                    {{ currentCount() }} / {{ progressForAria()?.totalItems }}
                </div>
            } @else if (progressForAria()?.itemsFetched) {
                <div class="text-xs text-gray-600">
                    {{ progressForAria()?.itemsFetched }} {{ 'sap-search-progress.items-fetched' | translate }}
                </div>
            }
        } @else {
            <div class="text-sm text-red-600">
                {{ progressForAria()?.errorMessage ?? ('sap-search-progress.unknown-error' | translate) }}
            </div>
        }
    </div>
}
